import React, { Component } from 'react';
import { TaskStore } from 'stores';
import { TaskActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import Tasks from './Tasks';
import {
  getVisibleTasks,
  getVisibleStudents,
  getVisibleGroups,
  getVisibleCourses
} from 'selectors/tasks';

export default class TasksContainer extends mixin(RefluxMixin, Component) {
  componentDidMount() {
    const { courseId, userId, taskId } = this.props.params;
    TaskActions.start({
      courseId,
      userId,
      taskId
    });
  }

  listenToStores() {
    this.listenToStoreWithMapper(TaskStore, state => {
      return {
        tasks: getVisibleTasks(state),
        tasksFilter: state.tasks.filter,
        tasksLoading: state.tasks.loading,
        students: getVisibleStudents(state),
        studentsLoading: state.students.loading,
        courses: getVisibleCourses(state),
        coursesLoading: state.courses.loading,
        coursesExpanded: state.courses.expanded,
        studentsExpanded: state.students.expanded,
        filterMode: state.filterMode
      };
    });
  }

  render() {
    return <Tasks {...this.state} />;
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Route/TasksContainer.js